A list of images associated with the advertisement branding.
